<!-- <link href="//maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css" rel="stylesheet" id="bootstrap-css">
<script src="//maxcdn.bootstrapcdn.com/bootstrap/4.1.1/js/bootstrap.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script> -->
<!------ Include the above in your HEAD tag ---------->

<!-- <div class="container login-container">
            <div class="row">
                <div class="col-md-6 offset-md-3 login-form-1">
                    <h3>Excursion Tracking</h3>
                    <form [formGroup]="loginForm" (ngSubmit)="login_FormSubmit()">
                        <div class="form-group">
                          <input type="text" class="form-control"  formControlName="username" placeholder="User Name" />      
                        </div>
                        <div class="form-group">
                          <input type="password" class="form-control" formControlName="password" placeholder="Password"/>    
                        </div>
                        <div class="form-group">
                            <input type="submit" class="btnSubmit" value="Login" />
                        </div>
                        <div class="form-group">
                            <a href="#" class="ForgetPwd">Forget Password?</a>
                        </div>
                    </form>
                </div>
            </div>
        </div> -->

        <!-- <div class="container">
          <div class="row">
              <div class="offset-md-2 col-lg-5 col-md-7 offset-lg-4 offset-md-3">
                  <div class="panel border bg-white">
                      <div class="panel-heading">
                          <h3 class="pt-3 font-weight-bold">Login</h3>
                      </div>
                      <div class="panel-body p-3">
                          <form action="login_script.php" method="POST">
                              <div class="form-group py-2">
                                  <div class="input-field">
                                      <span class="far fa-user p-2"></span>
                                      <input type="text" placeholder="Username or Email" required>
                                  </div>
                              </div>
                              <div class="form-group py-1 pb-2">
                                  <div class="input-field">
                                      <span class="fas fa-lock px-2"></span>
                                      <input type="password" placeholder="Enter your Password" required>
                                      <button class="btn bg-white text-muted">
                                          <span class="far fa-eye-slash"></span>
                                      </button>
                                  </div>
                              </div>
                              <div class="form-inline">
                                  <input type="checkbox" name="remember" id="remember">
                                  <label for="remember" class="text-muted">Remember me</label>
                                  <a href="#" id="forgot" class="font-weight-bold">Forgot password?</a>
                              </div>
                              <div class="btn btn-primary btn-block mt-3">Login</div>
                              <div class="text-center pt-4 text-muted">Don't have an account? <a href="#">Sign up</a>
                              </div>
                          </form>
                      </div>
                      <div class="mx-3 my-2 py-2 bordert">
                          <div class="text-center py-3">
                              <a href="https://wwww.facebook.com" target="_blank" class="px-2">
                                  <img src="https://www.dpreview.com/files/p/articles/4698742202/facebook.jpeg" alt="">
                              </a>
                              <a href="https://www.google.com" target="_blank" class="px-2">
                                  <img src="https://www.freepnglogos.com/uploads/google-logo-png/google-logo-png-suite-everything-you-need-know-about-google-newest-0.png"
                                      alt="">
                              </a>
  
                              <a href="https://www.github.com" target="_blank" class="px-2">
                                  <img src="https://www.freepnglogos.com/uploads/512x512-logo-png/512x512-logo-github-icon-35.png"
                                      alt="">
                              </a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div> -->


    <div *ngIf="this.appClient != 'RoyalPark' && this.appClient != 'RoyalAdventure'" class="login-page bg-light">
        <div class="container">
            <div class="row">
                <div class="col-lg-10 offset-lg-1">
                  <h4 class="mb-3">Login</h4>
                    <!-- <p style="text-align: center;">Login<p> -->
                    <div class="bg-white shadow rounded cardone">
                        <div class="row">
                            <div class="col-md-7 pe-0">
                                <div class="form-left h-100 py-5 px-5">
                                    <form [formGroup]="loginForm" (ngSubmit)="login_FormSubmit()" class="row g-4">
                                            <div class="col-12">
                                                <label>Username<span class="text-danger">*</span></label>
                                                <div class="input-group">
                                                    <!-- <div class="input-group-text"><i class="bi bi-person-fill"></i></div> -->
                                                    <input type="text" #myInput  class="form-control" formControlName="username" placeholder="Enter Username" style="margin-bottom:10px;">
                                                </div>
                                            </div>
    
                                            <div class="col-12">
                                                <label>Password<span class="text-danger">*</span></label>
                                                <div class="input-group">
                                                    <!-- <div class="input-group-text"><i class="bi bi-lock-fill"></i></div> -->
                                                    <input type="password" class="form-control" formControlName="password" placeholder="Enter Password">
                                                </div>
                                            </div>
    
                                            <!-- <div class="col-sm-6">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" id="inlineFormCheck">
                                                    <label class="form-check-label" for="inlineFormCheck">Remember me</label>
                                                </div>
                                            </div> -->
    
                                            <!-- <div class="col-sm-6">
                                                <a href="#" class="float-end text-primary">Forgot Password?</a>
                                            </div> -->
    
                                            <div class="col-12 row">
                                                <div class="col-md-4 offset-md-4"><button type="submit" class="btn btn-primary px-4 float-end mt-4">Login</button></div>
                                                <div class="col-md-4 offset-md-4"><button (click)="sendPsw()"  type="button" class="btn btn-secondary px-4 float-end mt-4">Forgot Password</button></div>
                                                
                                            </div>
                                    </form>
                                </div>
                            </div>
                            <div class="col-md-5 ps-0 d-none d-md-block">
                                <div class="form-right h-100 bg-primary text-white text-center pt-5">
                                    <i class="bi bi-bootstrap"></i>
                                    <h2 style="top: 125px;
                                    right: 56px;
                                    position: absolute;" class="fs-1">Excursion Tracking</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <p class="text-end text-secondary mt-3">Bootstrap 5 Login Page Design</p> -->
                </div>
            </div>
        </div>
    </div>


    <div *ngIf="this.appClient == 'RoyalPark' || this.appClient == 'RoyalAdventure'"  class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
        <div class="flex flex-column align-items-center justify-content-center">
            <!-- <img src="{{this.logoImg}}" alt="{{this.appClient}}" class="mb-5 w-13rem flex-shrink-0"> -->
            <div class="login-div-bg">
                <div class="w-full surface-card py-8 px-5 sm:px-8" style="border-radius:53px">
                    <div class="text-center mb-5">
                        <!-- <div class="text-900 text-3xl font-medium mb-3" style="font-size: 40px;">Login</div> -->
                        <img src="{{this.logoImg}}" alt="{{this.appClient}}" class="mb-1 w-10rem flex-shrink-0">
                        <img *ngIf="this.appClient == 'RoyalPark'" src="{{this.royalgulfImg}}" alt="{{this.appClient}}" class="mb-1 w-13rem flex-shrink-0">
                        <!-- <img src="../../assets/img/logo/royal_adv_logo.png" class="mb-1 w-10rem flex-shrink-0"> -->
                        <!--<img src="../../assets/img/logo/royal_gulf_logo.png" class="mb-1 w-13rem flex-shrink-0"> -->
                    </div>
                    <form [formGroup]="loginForm" (ngSubmit)="login_FormSubmit()">
                        <div>
                            <label for="Username" class="block text-900 text-xl font-medium mb-2">Username</label>
                            <input id="Username" type="text" placeholder="Username" formControlName="username" pInputText class="w-full md:w-30rem mb-5" style="padding:0.7 rem !important;font-size: 15px !important;">
        
                            <label for="Password" class="block text-900 font-medium text-xl mb-2">Password</label>
                            <input id="Password" type="password" placeholder="Password" formControlName="password" pInputText class="w-full md:w-30rem mb-5" style="padding:0.7 rem !important;font-size: 15px !important;">
        
                            <!-- <div class="flex align-items-center justify-content-between mb-5 gap-5">
                                <div class="flex align-items-center">
                                    <p-checkbox id="rememberme1" [binary]="true" styleClass="mr-2"></p-checkbox>
                                    <label for="rememberme1">Remember me</label>
                                </div>
                                <a class="font-medium no-underline ml-2 text-right cursor-pointer" style="color: var(--primary-color)">Forgot password?</a>
                            </div> -->
                            <div>
                                <button pButton pRipple label="Login" type="submit" class="btn-primary w-full p-3 text-xl" style="width: 50% !important"></button>
                                <button pButton pRipple label="Forgot Password" type="button" (click)="sendPsw()" class="btn-secondary w-full p-3 text-xl" style="width: 45% !important;float: right;"></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>    